/**
 * Maps delivery table column ids (and legacy bookmarked ?orderBy= values) to
 * Prisma scalar keys expected by findAllDelivery orderBy.
 */
export function toDeliveryListSortField(orderBy: string): string {
  const legacy: Record<string, string> = {
    averageOffersPrice: "medianPrice",
    averagePrice: "medianPrice",
    cancelledBy: "status",
    client: "clientLastName",
    clientAmount: "clientFinalPrice",
    contract: "publicId",
    deliveryDate: "carDeliveryDeadline",
    driverFinalPrice: "finalPrice",
    number_of_offers: "id",
    offersCount: "id",
    organization: "organizationId",
    price: "finalPrice",
    satisfaction: "rated",
  };
  return legacy[orderBy] ?? orderBy;
}
